import {createApp} from 'vue';
import {createPinia} from 'pinia';
import {setUpAlerting} from '@malt/alerting-vue3';
import {displayAppLoadingError} from 'malt-webmvc-common/src/main/js/vue-app-loader';
import {setUpAppContext} from './config/CustomerAppContextSetuper';
import {getDIContainer} from './config/DependencyInjection';
import {Vue3Mq} from 'vue3-mq';
import {VuePageViewTracking} from '@malt/tracking';

import App from './App.vue';
import router from '@/brief-hub/router';
import store from '@/brief-hub/store';
import I18nPlugin from '@malt/vue3-i18n';
import {features} from '@/common/plugins/features';
import {breakpoints} from '@/common/plugins/vue-mq-breakpoints';
import {RegisterExternalComponentsPlugin} from '@malt/joy-entrypoint/src/vue/plugins';
import {JoyVuePlugin} from '@maltjoy/core-vue/plugin';
import '@maltjoy/core-vue/dist/style.css';
import 'vue-tel-input/vue-tel-input.css';

const pinia = createPinia();

async function main() {
    try {
        await setUpAppContext(store);

        const app = createApp(App);

        const services = getDIContainer();
        Object.keys(services).forEach((serviceName) => {
            app.provide(serviceName, services[serviceName]);
        });

        app.use(I18nPlugin);
        app.use(features);
        app.use(router);
        app.use(VuePageViewTracking, router);
        app.use(store);
        app.use(pinia);
        app.use(Vue3Mq, {
            breakpoints,
        });
        app.use(JoyVuePlugin);
        app.use(RegisterExternalComponentsPlugin, {
            registerExternalComponents: ['autocomplete', 'calendar'],
        });

        if (window.SENTRY_CONFIGURATION) {
            setUpAlerting({
                configuration: window.SENTRY_CONFIGURATION,
                app,
                connectedUser: window.CONNECTED_USER,
                router,
            });
        }

        app.mount('#app');
    } catch (err) {
        displayAppLoadingError(err);
    }
}

main();
